window.addEventListener('load', function () {
    const popupLinks = document.querySelectorAll('[href="#contact-popup"], [href="#career-popup"]')

    popupLinks.forEach((link, index) => {
        link.addEventListener('click', () => {
            let popupContent = document.getElementById('glightbox-body')
            let forms = popupContent.querySelectorAll('.contact-form')

            forms.forEach((form, index) => {
                new window.contactForm.ContactForm(form)

                // Change inputs ID
                let inputs = form.querySelectorAll('input')
                inputs.forEach((input) => {
                    let id = input.getAttribute('id')

                    if (id) {
                        input.setAttribute('id', id.replace('frmContact', 'frmContactPopup-' + index))
                    }
                })

                let labels = form.querySelectorAll('label')
                labels.forEach((label) => {
                    let target = label.getAttribute('for')

                    if (target) {
                        label.setAttribute('for', target.replace('frmContact', 'frmContactPopup-' + index))
                    }
                })

                // Set recipient email and phone
                let email = link.getAttribute('data-email')
                if (email) {
                    let mailContact = popupContent.querySelector('.js-popup-email')
                    mailContact.innerText = email
                    mailContact.setAttribute('href', 'mailto:' + email)

                    popupContent.querySelector('#frmContactPopup-' + index + '_rec').value = email
                }

                let phone = link.getAttribute('data-phone')
                if (phone) {
                    let phoneContact = popupContent.querySelector('.js-popup-phone')
                    phoneContact.innerText = phone
                    phoneContact.setAttribute('href', 'tel:' + phone.replaceAll(' ', ''))
                }
            })
        })
    })
})